<template>
	<span>

		<FadeTransition>
			<base-nav
			container-classes="container-fluid"
			class="navbar-top border-bottom navbar-expand"
			id="navTop"
			:class="[{'standard-bg navbar-dark': type === 'default'}]"
		>
				<!--Top Navigation-->
				<img v-bind:src="pageLogo"  class="page-nav-logo" :alt="`${customer} logo`" />
				<b-nav pills class="top-nav-style custom-nav-style " v-if="!$sidebar.showSidebar">
					<!-- Home -->
					<top-home-default-group v-if="navigate.includes('HOME_DEFAULT')"></top-home-default-group>
					<top-home-mobility-group v-if="navigate.includes('HOME_MOBILITY')"></top-home-mobility-group>

					<!-- eSim -->
					<top-e-sim-group v-if="navigate.includes('ESIM')"></top-e-sim-group>

					<!-- OTA -->
					<top-ota-group v-if="navigate.includes('OTA')"></top-ota-group>

          <!-- ENTITLEMENTS -->
<!--          <top-entitlements-group v-if="navigate.includes('ENTITLEMENTS')"></top-entitlements-group>-->

          <!-- CDMA -->
					<top-cdma-group v-if="navigate.includes('CDMA')"></top-cdma-group>

					<!-- ENUM -->
					<top-enum-group v-if="navigate.includes('ENUM')"></top-enum-group>

					<!-- Reports -->
					<top-reports-basic-group v-if="navigate.includes('REPORTS_BASIC')"></top-reports-basic-group>
					<top-reports-group v-if="navigate.includes('REPORTS')"></top-reports-group>

					<!-- Troubleshooting -->
					<top-trouble-basic-group v-if="navigate.includes('TROUBLE_BASIC')"></top-trouble-basic-group>
					<top-trouble-custom-group v-if="navigate.includes('TROUBLE_CUSTOM')"></top-trouble-custom-group>

					<!-- Portal Administrator -->
					<top-admin-basic-group v-if="navigate.includes('ADMIN_DEFAULT')"></top-admin-basic-group>
					<top-admin-mobility-group v-if="navigate.includes('ADMIN_MOBILITY')"></top-admin-mobility-group>
					<top-admin-custom-group v-if="navigate.includes('ADMIN_CUSTOM')"></top-admin-custom-group>
				</b-nav>

				<!-- Navbar links -->
				<b-navbar-nav class="align-items-center ml-md-auto  ml-xs-left">
					<!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
					<li class="nav-item d-xl-none">
						<!-- Sidenav toggler -->
						<div
							class="pr-3 sidenav-toggler"
							:class="{
								active: $sidebar.showSidebar,
								'sidenav-toggler-dark': type === 'default',
								'sidenav-toggler-light': type === 'light',
							}"
							@click="toggleSidebar"
						>
							<div class="sidenav-toggler-inner">
								<i class="sidenav-toggler-line"></i>
								<i class="sidenav-toggler-line"></i>
								<i class="sidenav-toggler-line"></i>
							</div>

						</div>
					</li>

					<base-dropdown
						class="nav-item notification-display"
						tag="li"
						title-classes="nav-link"
						title-tag="a"
						icon="ni ni-bell-55"
						menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
					>
						<template>
							<!-- List group -->
							<b-list-group flush>
								<TransactionHistory></TransactionHistory>
							</b-list-group>
							<!-- View all -->
							<!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
						</template>
					</base-dropdown>
				</b-navbar-nav>
				<b-navbar-nav class="align-items-center ml-auto ml-md-0">
					<base-dropdown
						menu-on-right
						class="nav-item"
						tag="li"
						title-tag="a"
						:userName="userName"
						title-classes="nav-link pr-0"
					>
						<a href="#" class="nav-link header-user pr-0" @click.prevent slot="title-container">
							<b-media no-body class="align-items-center">
								<span class="avatar avatar-sm rounded-circle">
									<img :alt="userName" src="/img/theme/profile-avatar2.jpg" v-if="!uploadAvatarStatus" />
									<img :src="avatarSrc" :alt="userName" v-if="uploadAvatarStatus" />
								</span>
								<b-media-body class="ml-2 d-lg-block custom-name-style">
									<span class="mb-0 text-sm font-weight-bold" v-if="name">{{ name }} </span>
								</b-media-body>
							</b-media>
						</a>
						<b-dropdown-item class="custom-username-style">
							<i class="ni ni-single-02"></i>
							<span>{{name}}</span>
						</b-dropdown-item>

						<div class="dropdown-divider custom-username-style"></div>

						<b-dropdown-item to="/profile">
							<i class="fa fa-user-circle"></i>
							<span>Profile</span>
						</b-dropdown-item>

						<div class="dropdown-divider"></div>
							<ThemeSwitcher class="mx-3">
								<template #end>
									<div class="h2 ml-2 mt-2" :style="`font-size:14px; font-weight: 400`">
										Dark Mode
									</div>
								</template>
							</ThemeSwitcher>
						<div class="dropdown-divider"></div>

						<b-dropdown-item to="/activity">
							<i class="ni ni-calendar-grid-58"></i>
							<span>Activity</span>
						</b-dropdown-item>

						<b-dropdown-item to="/support">
							<i class="ni ni-support-16"></i>
							<span>Support</span>
						</b-dropdown-item>

						<b-dropdown-item to="/serverstatus" v-if="isPortalAdminStatus">
							<i class="ni ni-support-16"></i>
							<span>Server Status</span>
						</b-dropdown-item>

						<b-dropdown-item v-on:click="showAboutStatus = !showAboutStatus">
							<i class="fab fa-safari"></i>
							<span>About</span>
						</b-dropdown-item>

	<!--					<b-dropdown-item to="/portal-settings" v-if="isPortalAdminStatus">-->
	<!--						<i class="ni ni-settings"></i>-->
	<!--						<span>Portal Settings</span>-->
	<!--					</b-dropdown-item>-->

						<div class="dropdown-divider"></div>

						<b-dropdown-item v-on:click="onLogOut()">
							<i class="ni ni-user-run"></i>
							<span>Logout</span>
						</b-dropdown-item>
					</base-dropdown>
				</b-navbar-nav>
			</base-nav>

		</FadeTransition>
		<b-modal centered  hide-footer	size="sm" v-model="showAboutStatus" id="about-us-modal">
			<about-app />
		</b-modal>
	</span>

</template>

<script>
import { FadeTransition} from "vue2-transitions";
import {BaseNav, Modal} from "@/components";
import {LOGOUT} from "../../store/auth.module";
import configDirective from "../../common/directive/config-directive";
import AuthService from "../../common/api-services/auth-service";
import initService from "../../common/api-services/init-service";
import TransactionHistory from "../Pages/UserProfile/Transaction-History";
import VueCoreImageUpload from "vue-core-image-upload";
import TopAdminBasicGroup from "./TopGroup/Top-Admin-Basic-Group.vue";
import TopAdminMobilityGroup from "./TopGroup/Top-Admin-Mobility-Group.vue";
import TopAdminCustomGroup from "./TopGroup/Top-Admin-Custom-Group.vue";
import TopHomeDefaultGroup from './TopGroup/Top-Home-Default-Group.vue';
import TopHomeMobilityGroup from './TopGroup/Top-Home-Mobilty-Group.vue';
import TopCdmaGroup from "./TopGroup/Top-Cdma-Group.vue";
import TopESimGroup from "./TopGroup/Top-E-Sim-Group.vue";
import TopOtaGroup from "./TopGroup/Top-Ota-Group.vue";
// import TopEntitlementsGroup from "./TopGroup/Top-Entitlements-Group";
import TopReportsGroup from "./TopGroup/Top-Reports-Group.vue"
import TopReportsBasicGroup from "./TopGroup/Top-Reports-Basic-Group.vue";
import TopTroubleBasicGroup from "./TopGroup/Top-Trouble-Basic-Group.vue";
import TopTroubleCustomGroup from "./TopGroup/Top-Trouble-Custom-Group.vue";
import AboutApp from "../Components/About-App.vue";
import TopEnumGroup from './TopGroup/Top-Enum-Group.vue';
import ThemeSwitcher from '@/views/Components/Theme-Switcher.vue';

export default {
	components: {
		FadeTransition,
		BaseNav,
		Modal,
		VueCoreImageUpload,
		TransactionHistory,
		TopAdminBasicGroup,
		TopAdminMobilityGroup,
		TopAdminCustomGroup,
		TopHomeDefaultGroup,
		TopHomeMobilityGroup,
		TopCdmaGroup,
//    TopEntitlementsGroup,
		TopESimGroup,
		TopOtaGroup,
		TopReportsGroup,
		TopReportsBasicGroup,
		TopTroubleBasicGroup,
		TopTroubleCustomGroup,
		AboutApp,
		TopEnumGroup,
		ThemeSwitcher
	},
	props: {
		type: {
			type: String,
			default: "default", // default|light
			description: "Look of the dashboard navbar. Default (Green) or light (gray)",
		},
	},
	computed: {
		routeName() {
			const {name} = this.$route;
			return this.capitalizeFirstLetter(name);
		},
	},
	data() {
		return {
			activeNotifications: false,
			showMenu: false,
			searchModalVisible: false,
			searchQuery: "",
			topNav: [],
			userName: "",
			navTopBar: [],
			isAdminStatus: false,
			hasImage: false,
			uploadAvatarStatus: false,
			avatarSrc: "",
			name: "",
			getUserGroupInfo: null,
			isPortalAdminStatus: false,
			isReadonyStatus: false,
			pageLogo: null,
			customer: null,
			navigate: [],
			showAboutStatus: false,
		};
	},
	mounted() {

		// this.name = initService.getNameInfo();
		const nameInfo = initService.getNameInfo();
		this.name = nameInfo !== null ? this.name = nameInfo : ""
		this.userName = initService.getUserNameInfo();
		this.getUserGroupInfo = initService.getGroupInfo();
		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		this.groups = initService.getGroups();
		this.pageLogo = '/img/brand/'+process.env.VUE_APP_CLIENT.toString() +'.png';
		this.customer = process.env.VUE_APP_CLIENT.toString();

    let avatar = configDirective.getCustomerAvatar();
    if (!avatar) avatar = '/img/avatar/avatar0.png';
    //console.log('avatar:',avatar);
    if (avatar) {
      this.avatarSrc = avatar;
      this.hasImage = true;
      this.uploadAvatarStatus = true;
    }

		this.$root.$on("uploadImage", imageSrc => {
			this.uploadAvatarStatus = true;
			this.avatarSrc = imageSrc;
		});


		this.navigate = configDirective.getNavigation();

	},
	methods: {
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		toggleNotificationDropDown() {
			this.activeNotifications = !this.activeNotifications;
		},
		closeDropDown() {
			this.activeNotifications = false;
		},
		toggleSidebar() {
			this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
		},
		hideSidebar() {
			this.$sidebar.displaySidebar(false);
		},
		async onLogOut() {
			setTimeout(() => {
				initService.clearCache();
			}, 400);
			AuthService.logoutService().then(res => {
				this.$store.dispatch(LOGOUT).then(() => this.$router.push({name: "login"}));
			});
		},

		showTopNav() {
			this.$sidebar.showSidebar = !this.$sidebar.showSidebar;
		},
	},
};
</script>
<style>
[v-clock] {
	display: none !important;
}
</style>
